import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import Registration from 'features/auth/ui/Auth/Registration';
import {registerUserLoadingSelector} from 'entities/user';

const RegistrationScreen: React.FC = () => {
    const isLoading = useSelector(registerUserLoadingSelector);

    return (
        <BlankLayout pageTitle={t`Регистрация`} isLoading={isLoading}>
            <Registration/>
        </BlankLayout>
    );
};

export default RegistrationScreen;
